import * as yup from 'yup';

export default yup.object({
  email: yup.string().email().required(),
  password: yup
    .string()
    .min(8, 'A senha deve ter um tamanho mínimo de 8 caracteres!')
    .required(),
});
